module.exports = __webpack_public_path__ + "static/media/li.9be1eca0.svg";